import React from 'react';
import { FaBars } from 'react-icons/fa';
import './NavbarToggler.css';

function NavbarToggler({ onClick, className }) {
  return (
    <button className={`navbar-toggler ${className}`} onClick={onClick}>
      <FaBars />
    </button>
  );
}

export default NavbarToggler;
